import React from 'react';

const WaveMove = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 834 834"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1,
        }}
        {...props}
    >
        <g id="Move">
            <g>
                <path d="M66.474,790.121l119.619,-119.618c8.827,-8.828 8.827,-23.161 0,-31.988c-8.828,-8.827 -23.161,-8.827 -31.988,0l-119.619,119.619c-8.827,8.827 -8.827,23.16 0,31.987c8.827,8.828 23.161,8.828 31.988,0Z" />
                <path d="M492.689,363.907l119.618,-119.619c8.828,-8.827 8.828,-23.161 0,-31.988c-8.827,-8.827 -23.16,-8.827 -31.988,0l-119.618,119.619c-8.828,8.827 -8.828,23.16 0,31.988c8.827,8.827 23.16,8.827 31.988,0Z" />
                <g>
                    <g>
                        <path
                            d="M250.851,581.941c0,0 66.181,77.205 33.4,109.986c-31.911,31.911 -109.986,-33.4 -109.986,-33.4"
                            style={{ fill: 'none', strokeWidth: 45.42 }}
                        />
                        <path
                            d="M248.894,579.554c0,0 -66.181,-77.205 -33.4,-109.986c31.911,-31.91 109.986,33.4 109.986,33.4"
                            style={{ fill: 'none', strokeWidth: 45.42 }}
                        />
                    </g>
                    <g>
                        <path
                            d="M402.066,427.034c0,0 66.181,77.205 33.4,109.986c-31.911,31.911 -109.986,-33.4 -109.986,-33.4"
                            style={{ fill: 'none', strokeWidth: 45.42 }}
                        />
                        <path
                            d="M400.109,424.647c0,0 -66.181,-77.205 -33.4,-109.986c31.911,-31.911 109.986,33.4 109.986,33.4"
                            style={{ fill: 'none', strokeWidth: 45.42 }}
                        />
                    </g>
                </g>
                <path d="M725.436,103.735l-52.429,257.451l-214.15,-206.817l266.579,-50.634Z" />
            </g>
        </g>
    </svg>
);

export default WaveMove;
